module.exports = "<button class=\"nominas-sumario-lista-item-revisiones__revision\"\r\n    ng-repeat=\"revision in ::$ctrl.catalogo.nominaRevision\"\r\n    ng-disabled=\"!$ctrl.editable || $ctrl.procesando[revision.id]\"\r\n    ng-class=\"{\r\n      'nominas-sumario-lista-item-revisiones__revision--activo': $ctrl.data[revision.id],\r\n      'nominas-sumario-lista-item-revisiones__revision--procesando': $ctrl.procesando[revision.id],\r\n    }\"\r\n    ng-click=\"$ctrl.toggle(revision.id)\">\r\n  {{::revision.descripcion}}\r\n</button>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/nominas/sumario/components/lista/item/revisiones/template.html
// module id = 1656
// module chunks = 0